
import request from '@/utils/request'
import URL from '@/api/baseUrl'
export default class Tenant {
  /**
   * 通过租户code查询租户信息
   * @param code
   */
  static getByCode (code) {
    return request.get(`${URL.system}/tenant/code/${code}`)
  }
}
